module.exports = __webpack_public_path__ + "static/media/icon-1.f8ed14f6.png";